import { render, staticRenderFns } from "./VendorRequestTable.vue?vue&type=template&id=4f5417f4"
import script from "./VendorRequestTable.vue?vue&type=script&lang=js"
export * from "./VendorRequestTable.vue?vue&type=script&lang=js"
import style0 from "./VendorRequestTable.vue?vue&type=style&index=0&id=4f5417f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports